import { Link } from "react-router-dom";

export const Projekts = () => {
  return (
    <div className="home">
      <div className="canvas home">
        <h1>React</h1>
        <Link
          className="canvas"
          to={{
            pathname:
              "https://react-entrega-s1-hamburgueria-da-kenzie-rhamo1.vercel.app/",
          }}
          target="_blank"
        >
          Hamburgueria
        </Link>
        <Link
          className="canvas"
          to={{
            pathname:
              "https://react-atividade-s2-praticando-forms-rhamo1.vercel.app/",
          }}
          target="_blank"
        >
          Forms
        </Link>
      </div>
    </div>
  );
};
